// FieldPulse Api returns mountains of data that we don't need..
// In order to trim our memory foot print.. and prevent OutOfMemory crashes..
// only keep data we need.

export const filterCustomer = (customer) => {
  if (!customer) return {};
  
  const {
    id,
    company_id,
    first_name,
    last_name,
    company_name,
    status,
    address_1,
    address_2,
    city,
    state,
    zip_code,
    assigned,
    assigned_to,
    country_code,
    email,
    phone,
    phone_e164,
    has_valid_phone,
    alt_email,
    alt_phone,
    secondary_email,
    secondary_phone,
  } = customer;

  const assignedData = assigned ? filterAssigned(assigned) : null;

  return {
    id,
    company_id,
    first_name,
    last_name,
    name: `${first_name || ""} ${last_name || ""}`.trim(),
    company_name,
    status,
    address_1,
    address_2,
    city,
    state,
    zip_code,
    assigned: assignedData,
    assigned_to,
    country_code,
    email,
    phone,
    phone_e164,
    has_valid_phone,
    alt_email,
    alt_phone,
    secondary_email,
    secondary_phone,
  };
};

export const filterCustomerWithRelations = (customer) => {
  if (!customer) return {};

  const customerData = filterCustomer(customer);
  const { invoices, jobs, tags, customfields, estimates, files } = customer;
  return {
    ...customerData,
    invoices,
    jobs,
    tags,
    customfields,
    estimates,
    files,
  };
};

export const filterAssigned = (assigned) => {
  const { id, avatar, first_name, last_name, email, role, founder } =
    assigned || {};
  return {
    id,
    avatar,
    first_name,
    last_name,
    email,
    role,
    founder,
  };
};
